<template>
  <div>
    <div class="header-container">
      <div class="receipt">
        <h3>{{ $t('access.allowed') }}</h3>
        <p @click="handleOnPaymentReceiptShowing">
          {{ $t('transaction.number') }}: <span>{{ paymentId }}</span>
        </p>
      </div>
      <div v-if="language" class="language">
        <localization-controller :language="language" />
      </div>
    </div>

    <transition name="fade">
      <modal-paid-with-content
        v-if="isPaymentReceiptShown"
        @hide="handleOnPaymentReceiptClosing"
      />
    </transition>
  </div>
</template>

<script>
import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';

import ModalPaidWithContent from '@/components/modals/ModalPaidWithContent';
import LocalizationController from 'organisms/localization/LocalizationController';

export default {
  name: 'DigitalContentHeader',
  components: {
    ModalPaidWithContent,
    LocalizationController,
  },
  props: {
    paymentId: {
      type: String,
      required: true,
    },
    language: {
      type: Object,
    },
  },
  data() {
    return {
      isPaymentReceiptShown: false,
    };
  },
  methods: {
    handleOnPaymentReceiptShowing() {
      this.isPaymentReceiptShown = true;

      disableBodyScroll(document.body);
    },
    handleOnPaymentReceiptClosing() {
      this.isPaymentReceiptShown = false;

      enableBodyScroll(document.body);
    },
  },
};
</script>

<style lang="sass" scoped>
  .header-container
    position: relative
    display: flex
    align-items: flex-start
    justify-content: space-between
    padding: 15px 0

    &::before
      content: ''
      width: 3rem
      height: 3rem
      position: absolute
      top: 50%
      left: -13px
      transform: translateY(-50%) rotate(10deg)
      background: url('~@/assets/images/header-icon-like.svg') left center / contain no-repeat

    p
      font-size: 12px
      line-height: 140%
      color: rgba(33, 33, 33, 0.5)

    .receipt
      display: inline-block
      padding-left: 3.6rem

      h3
        margin-bottom: .2rem
        font-weight: 600
        font-size: 18px
        line-height: 120%
        color: #212121

      p
        position: relative
        display: flex
        flex-direction: column
        padding-left: 30px
        cursor: pointer

      span
        position: relative
        color: #9B51E0

        &::before
          content: ''
          width: 20px
          height: 20px
          position: absolute
          top: -10px
          left: -30px
          background: url('~@/assets/images/icon-bill.svg') center center / contain no-repeat

    .language
      flex: none
      padding: 0 10px
      cursor: pointer
</style>
